import { Icon, useOnClickOutside } from '@elotech/components';
import classnames from 'classnames';
import * as uiActions from 'common/ui/Actions.js';
import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';

import CollapsibleMenu from './CollapsibleMenu.react.js';
import MenuItem from './MenuItem.react.js';

export const Menu = ({
  menu,
  sidebarToggled,
  sidebarToggle,
  config,
  auth,
  keycloak
}) => {
  const searchRef = useRef(null);
  const asideRef = useRef(null);
  const ulRef = useRef(null);

  const [search, setSearch] = useState('');
  const [focusedSearchInput, setFocusedSearchInput] = useState(false);

  useOnClickOutside(asideRef, () => setFocusedSearchInput(false));

  const [hover, setHover] = useState(false);

  const hasAccess = seletor => {
    if (config.isCloud) {
      return getAccessKeycloak(seletor);
    }

    return getAccessSeletor(seletor);
  };

  const getAccessSeletor = seletor => {
    if (seletor && auth) {
      return auth.hasIn(['userAccess', 'telas', seletor]);
    }

    return true;
  };

  const getAccessKeycloak = seletor => {
    if (seletor && keycloak) {
      return keycloak.hasIn(['userAccess', 'roles', seletor]);
    }

    return true;
  };

  const onClickMenuItem = event => {
    event.stopPropagation();

    if (!sidebarToggled && window.innerWidth < 1025) {
      sidebarToggle();
    }
  };

  const containsSearch = menuItem => {
    return (
      (menuItem.get('menu') &&
        menuItem.get('menu').toLowerCase().includes(search.toLowerCase())) ||
      (menuItem.get('caption') &&
        menuItem.get('caption').toLowerCase().includes(search.toLowerCase()))
    );
  };

  const createMenuItem = (menuItem, itemType) => {
    let isExternal = false;

    if (menuItem.get('route')) {
      const seletor = menuItem.get('seletor');

      if (menuItem.get('isExternal')) {
        isExternal = menuItem.get('isExternal');
      }

      const shouldRenderItem = menuItem.get('show')
        ? menuItem.get('show')() && hasAccess(seletor)
        : hasAccess(seletor);

      if (shouldRenderItem && containsSearch(menuItem)) {
        return (
          <MenuItem
            key={`${menuItem.get('route')}_${menuItem.get('id')}_${menuItem.get(
              'title'
            )}`}
            route={menuItem.get('route')}
            caption={menuItem.get('caption')}
            image={menuItem.get('image')}
            itemType={itemType}
            isExternal={isExternal}
            onClickMenuItem={onClickMenuItem}
            getIsHover={setHover}
          />
        );
      }
    }

    return null;
  };

  const renderMenu = menuItem => {
    if (menuItem.get('route')) {
      return createMenuItem(menuItem, 'father');
    } else if (menuItem.get('menu')) {
      const items = menuItem
        .get('submenus')
        .map(renderMenu)
        .filter(item => item !== null);

      if (!items.isEmpty()) {
        return (
          <CollapsibleMenu
            key={menuItem.get('menu')}
            menuItem={menuItem}
            getIsHover={setHover}
          >
            <div>{items}</div>
          </CollapsibleMenu>
        );
      }
    }

    return null;
  };

  const classNameSidebar = classnames('sidebar', {
    'sidebar-toggle': sidebarToggled
  });

  const classNameSidebarRebranding = classnames(`${classNameSidebar} new`, {
    'float-type': sidebarToggled,
    'focused-search': focusedSearchInput,
    hover: hover
  });

  return (
    <aside ref={asideRef} className={classNameSidebarRebranding}>
      <div className="sidebar-search">
        <input
          value={search}
          ref={searchRef}
          aria-label="input-search"
          placeholder="Buscar em Menu..."
          onFocus={() => setFocusedSearchInput(true)}
          onChange={({ target }) => setSearch(target.value)}
        />
        <i
          className="fa fa-search"
          aria-hidden="true"
          onClick={() => searchRef.current && searchRef.current.focus()}
        />
      </div>

      <ul ref={ulRef} className="sidebar-itens">
        <div>{menu.filter(i => i && !!i).map(renderMenu)}</div>
      </ul>

      <button
        className="header-toggle-sidebar toggle-control hidden-xs hidden-sm"
        aria-label="Botão para expandir o menu"
        onClick={sidebarToggle}
      >
        <Icon
          className="mr-xs"
          icon={sidebarToggled ? 'angle-double-right' : 'angle-double-left'}
        />
        {sidebarToggled ? '' : 'Recolher Menu'}
      </button>
    </aside>
  );
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
    keycloak: state.keycloak,
    config: state.config,
    sidebarToggled: state.ui.sidebarToggled,
    sidebarToggle: state.ui.sidebarToggle,
    area_icon: state.info.get('area_icon'),
    module_icon: state.info.get('module_icon'),
    description: state.info.get('description')
  };
}

export default connect(mapStateToProps, uiActions)(Menu);
